// extracted by mini-css-extract-plugin
export default {"bookBtn":"LabTest_bookBtn__GMCnT"};